import { Button, Divider, Grid, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import EditIcon from '../../../components/Common/EditIcon'
import TitleValueDisplay from '../../../components/Common/TitleValueDisplay'
import { isNotEmpty } from '../../../helpers/StringHelpers'
import { useSignupStore } from '../../../store/signup/UserSignupStore'
import moment from "moment"
import { SignupRoute, SignupRouteParams } from '../SignupFlow/SignupFlow'
// import { NEW_COMPANY_CODE } from '../../../services/ntuc/userService/company'

function ReviewPage(props: SignupRouteParams) {
    const { onNavigateTo } = props
    const { t } = useTranslation(`signup`)
    const [state] = useSignupStore()

    const {
        addressAndEmploymentDetail,
        bankDetail,
        personalDetail,
        referralDetail,
    } = state

    const {
        jobTitle,
        occupationalGroup,
        companyName,
        monthlySalary,
        postalCode,
        houseNumber,
        streetName,
        unitNumber,
        floorNumber,
        buildingName,
    } = addressAndEmploymentDetail

    const {
        accountNumber,
        bankName,
    } = bankDetail

    const {
        nric,
        name,
        cardName,
        dateOfBirth,
        mobileNumber,
        email,
        gender,
        residentialStatus,
        race,
        maritalStatus,
        educationalStatus,
    } = personalDetail

    const {
        referralCode,
        recruiterCode,
    } = referralDetail

    const dateString = dateOfBirth ? moment(dateOfBirth).format(`DD/MM/YYYY`) : ``
    let address = t(`block`) + ` `
        + houseNumber + ` `
        + streetName + `, `
        + `#` + floorNumber + `-`
        + unitNumber + `, `
        + postalCode

    address += isNotEmpty(buildingName) ? `, ` + buildingName : ``

    const handleConfirmButtonClick = () => {
        onNavigateTo(SignupRoute.TermsAndConditions)
    }

    const handleEditClick = (value: string) => {
        onNavigateTo(SignupRoute.Form, { form: { edit: value } })
    }

    const genderTitle = () => {
        if (gender === `F`) {
            return t(`gender.female`)
        } else if (gender === `M`) {
            return t(`gender.male`)
        } else {
            return t(`gender.other`)
        }
    }

    return (
        <Grid container rowSpacing={2} columnSpacing={{ xs: `16px`, sm: `24px`, md: `24px`, lg: `40px` }}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
                <Typography variant="h2">{t(`review.title`)}</Typography>
                <Divider />
                <Typography variant="h4" mt={4} mb={2}>{t(`review.header`)}</Typography>
                <Typography mb={2}>{t(`review.subheader`)}</Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
                <Typography variant="h4">{t(`tabs.personal.label`)}</Typography>
                <Divider />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
                <TitleValueDisplay title={t(`nric`)} value={nric} />
            </Grid>
            <Grid item xs={0} sm={0} md={6} lg={6} />
            <Grid item xs={12} sm={12} md={6} lg={6}>
                <TitleValueDisplay title={t(`name`)} value={name} />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
                <TitleValueDisplay title={t(`card_name`)} value={cardName} />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
                <TitleValueDisplay title={t(`dob`)} value={dateString} />
            </Grid>
            <Grid item xs={0} sm={0} md={6} lg={6} />
            <Grid item xs={12} sm={12} md={6} lg={6}>
                <TitleValueDisplay title={t(`gender`)} value={genderTitle().toUpperCase()} />
            </Grid>
            <Grid item xs={0} sm={0} md={6} lg={6} />

            <Grid item xs={12} sm={12} md={6} lg={6}>
                <TitleValueDisplay title={t(`mobile_number`)} value={mobileNumber} />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
                <TitleValueDisplay title={t(`email`)} value={email} />
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={6}>
                <TitleValueDisplay title={t(`residential_status`)} value={residentialStatus.value} />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
                <TitleValueDisplay title={t(`race`)} value={race.value} />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
                <TitleValueDisplay title={t(`marital_status`)} value={maritalStatus.value} />
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={6}>
                <TitleValueDisplay title={t(`education`)} value={educationalStatus.value} />
            </Grid>

            <Grid item xs={0} sm={0} md={9} lg={9} />
            <Grid item xs={12} sm={12} md={3} lg={3} marginTop={2} marginBottom={5}>
                <Button onClick={() => handleEditClick(`personal`)} variant='outlined' color='primary' fullWidth startIcon={<EditIcon fontSize="small" color="primary" />} >{t(`edit`)}</Button>
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12}>
                <Typography variant="h4">{t(`tabs.employment.label`)}</Typography>
                <Divider />
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12}>
                <Typography variant="h6">{t(`contact_details`)}</Typography>
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={6}>
                <TitleValueDisplay title={t(`home_address`)} value={address} />
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12}>
                <Typography variant="h6">{t(`employment_details`)}</Typography>
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={6}>
                <TitleValueDisplay title={t(`job_title`)} value={jobTitle} />
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={6}>
                <TitleValueDisplay title={t(`occupational_group`)} value={occupationalGroup.value} />
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={6}>
                <TitleValueDisplay title={t(`company`)} value={companyName.name} />
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={6} hidden={!(companyName.businessNature)}>
                <TitleValueDisplay title={t(`business_nature`)} value={companyName.businessNature} />
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={6}>
                <TitleValueDisplay title={t(`salary`)} value={monthlySalary.value} />
            </Grid>
            <Grid item xs={0} sm={0} md={9} lg={9} />
            <Grid item xs={12} sm={12} md={3} lg={3} marginTop={2} marginBottom={5}>
                <Button onClick={() => handleEditClick(`employment`)} variant='outlined' color='primary' fullWidth startIcon={<EditIcon sx={{ fontSize: 14 }} color="primary" />}>{t(`edit`)}</Button>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
                <Typography variant="h4">{t(`tabs.bank.label`)}</Typography>
                <Divider />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
                <TitleValueDisplay title={t(`bank_name`)} value={bankName.value} />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
                <TitleValueDisplay title={t(`account_no`)} value={accountNumber} />
            </Grid>
            <Grid item xs={0} sm={0} md={9} lg={9} />
            <Grid item xs={12} sm={12} md={3} lg={3} marginTop={2}>
                <Button onClick={() => handleEditClick(`bank`)} variant='outlined' color='primary' fullWidth startIcon={<EditIcon sx={{ fontSize: 14 }} color="primary" />}>{t(`edit`)}</Button>
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12}>
                <Typography variant="h4">{t(`tabs.referral.label`)}</Typography>
                <Divider />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
                <TitleValueDisplay title={t(`referral.referral_code`)} value={referralCode} />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
                <TitleValueDisplay title={t(`referral.recruiter_code`)} value={recruiterCode} />
            </Grid>
            <Grid item xs={0} sm={0} md={9} lg={9} />
            <Grid item xs={12} sm={12} md={3} lg={3} marginTop={2}>
                <Button onClick={() => handleEditClick(`referral`)} variant='outlined' color='primary' fullWidth startIcon={<EditIcon sx={{ fontSize: 14 }} color="primary" />}>{t(`edit`)}</Button>
            </Grid>

            <Grid item md={3}></Grid>

            <Grid item xs={12} sm={12} md={6} lg={6} marginTop={2} marginBottom={2}>
                <Button variant='contained' color='primary' fullWidth onClick={handleConfirmButtonClick}>{t(`confirm_application`, { ns: `common` })}</Button>
            </Grid>
        </Grid>
    )
}

export default ReviewPage
